import * as THREE from 'three';
import { ExtrudeHandlePartGroup } from './ExtrudeHandlePartGroup';

/**
 * 拉伸手柄部件集合。
 */
export interface ExtrudeHandleGizmoParts {
  /** 轴体。 */
  shaft: ExtrudeHandlePartGroup;
  /** 正向主手柄。 */
  positivePrimaryHead: ExtrudeHandlePartGroup;
  /** 反向主手柄。 */
  negativePrimaryHead: ExtrudeHandlePartGroup;
  /** 正向次手柄。 */
  positiveSecondaryHead: ExtrudeHandlePartGroup;
  /** 反向次手柄。 */
  negativeSecondaryHead: ExtrudeHandlePartGroup;
}

/**
 * 拉伸手柄根对象。
 *
 * 设计说明：
 * 1. 根对象直接保存所有部件引用，作为唯一手柄部件真相；
 * 2. 显示更新、拾取过滤和拖拽命中统一从 `parts` 读取；
 * 3. 宿主层只认这一种手柄根对象，不再额外维护平行的运行时中间标签。
 */
export class ExtrudeHandleGizmoObject extends THREE.Group {
  /** 运行时类型标记。 */
  public readonly isExtrudeHandleGizmoObject = true;

  /** 是否跳过常规选择链。 */
  public readonly skipSelection = true;

  /** 手柄部件集合。 */
  public readonly parts: ExtrudeHandleGizmoParts;

  /**
   * 构造函数。
   *
   * @param parts 手柄部件集合。
   */
  public constructor(parts: ExtrudeHandleGizmoParts) {
    super();
    this.parts = parts;
  }
}
